import React, { useState } from "react";
// import IP from "../../../images/IP_Image.png"
import IP from "../../../images/peck2.jpg";
// import TajMahal from "../../../images/TajMahal.png"
import TajMahal from "../../../images/Group 706.png";
import InputAdornment from "@mui/material/InputAdornment";
// import "../NewPassword/NewPassword.css"
// import "../components/common/NewPassword/NewPassword.css"
import "../../common/NewPassword/NewPassword.css";
import TextField from "@mui/material/TextField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { REGULAR_EXPRESSION, postRequestGlobal } from "../../../API/global";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// import CircularProgress from '@mui/material/CircularProgress';
import pecock_vdo from "../../../images/peco.gif";
import Box from "@mui/material/Box";
import ph_logo from "../../../images/IFFFI_LOGO.png";
import ph_Nfdc from "../../../images/NFDC-Logo.png";

const ChangedPasswordDetails = ({
  changedPassword,
  errors,
  handlePasswordChange,
  passwordError,
}) => {
  const navigate = useNavigate();

  // const [password, setPassword] = useState('');
  // const [confirmPassword, setConfirmPassword] = useState('');
  const [showPasswordOne, setShowPasswordOne] = React.useState(false);
  const [showPasswordTwo, setShowPasswordTwo] = React.useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [confirmPasswordErrorMsg, setConfirmPasswordErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [formData, setFormData] = useState({
    email: changedPassword.email,
    password: "",
    password_confirmation: "",
  });

  const handleClickShowPasswordOne = () => setShowPasswordOne((show) => !show);
  const handleClickShowPasswordTwo = () => setShowPasswordTwo((show) => !show);

  const handleMouseDownPasswordOne = (event) => {
    event.preventDefault();
  };
  const handleMouseDownPasswordTwo = (event) => {
    event.preventDefault();
  };

  const backtologinpage = async (e) => {
    navigate("/");
  };

  // const validatePassword = (name, value) => {
  //   console.log({ name });

  //   let flag = true;
  //   if (name === 'password') {

  //     if (value !== formData.password_confirmation && formData.password_confirmation) {

  //       setConfirmPasswordErrorMsg('Passwords do not match');
  //       flag = false;
  //     } else {
  //       setConfirmPasswordErrorMsg('');
  //     }

  //   }
  //   if (name === 'password_confirmation') {

  //     if (value !== formData.password) {
  //       setConfirmPasswordErrorMsg('Passwords do not match');
  //       flag = false;
  //     } else {
  //       setConfirmPasswordErrorMsg('');
  //     }
  //   }
  //   const regex = REGULAR_EXPRESSION;

  //   let data = regex.test(value);
  //   if (data) {
  //     setPasswordErrorMsg('');

  //   } else {

  //     setPasswordErrorMsg('Password must be at least 8 characters long and include at least 1 alphabet, 1 number, and 1 special character.');
  //     flag = false;
  //   }
  //   console.log({ flag });
  //   return flag
  // };

  const validatePassword = async (password) => {
    // console.log("validatePassword 2")
    // console.log({password})
    let data = REGULAR_EXPRESSION.test(password);
    // console.log({ data })
    if (data) {
      // console.log("passdata")
      setPasswordErrorMsg("");
      return true;
    } else {
      setPasswordErrorMsg(
        "Password must be at least 8 characters long and include at least 1 alphabet, 1 number, and 1 special character."
      );
      return false;
    }
  };

  const handlePasswordValidation = (e) => {
    handlePasswordChange(e);
    const { name, value } = e.target;
    //  console.log("data logic 2");
    let flag = true;

    // console.log(name, value);

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "password_confirmation") {
      setPasswordMatchError(
        value !== formData.password ? "Passwords do not match" : ""
      );
    }

    if (name === "password") {
      validatePassword(value);
      setPasswordMatchError(
        formData.password_confirmation !== value ? "Passwords do not match" : ""
      );
    }

    // validatePassword(name, value)
  };
  const handleSubmitChangedPassword = async (e) => {
    e.preventDefault();

    // Check if password fields are blank
    if (!formData.password || !formData.password_confirmation) {
      alert("Password fields cannot be blank.");
      return false;
    }

    // Validate individual password fields
    if (!validatePassword(formData.password)) {
      // alert("please review your data");
      return false;
    }

    // Check if passwords match
    if (formData.password !== formData.password_confirmation) {
      // Optionally, set an error message or alert here
      // setAlertMessage('Passwords do not match.');
      // setAlertSeverity('error');
      // setAlertOpen(true);
      return false;
    }

    if (passwordError || passwordMatchError) {
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
      };
      const response = await postRequestGlobal(
        "forgot/changePassword",
        payload
      );

      // Handle success or further actions here, such as redirecting to another page
      setAlertMessage("Password changed successfully!");
      setAlertSeverity("success");
      setAlertOpen(true);

      setTimeout(() => {
        navigate("/");
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error: ", error);
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  };

  return (
    <>
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          //  bgcolor="rgba(255, 255, 255, 0.1)" zIndex={1000}>
          bgcolor="#1c682c7d"
          zIndex={1000}
        >
          {/* <CircularProgress /> */}
          <img src={pecock_vdo} alt="Loading..." />
        </Box>
      )}
      <div className="container-fluid px-0 w-100 overflow-x-hidden position-absolute">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <img
              src={IP}
              className="mob-IP"
              alt="Indian Panorama"
              width="100%"
              height="773vh"
            />
          </div>
          <div className={"col-sm-12 col-md-12 col-lg-6 second-box"}>
            <div className="logo-Phone">
              <a href={process.env.REACT_APP_HOME_URL}>
                <img
                  src={ph_logo}
                  className=""
                  alt="Indian Panorama"
                  width="85px"
                  height="auto"
                />
              </a>
              <img
                src={ph_Nfdc}
                className=""
                alt="Indian Panorama"
                width="85px"
                height="auto"
              />
            </div>
            <div className="container">
              <div className="row">
                {/* <p className='register me-3' style={{ cursor: "pointer" }}><p onClick={backtologinpage}><b>Go to previous page</b></p></p> */}
                <div className="col-sm-1 col-md-1 col-lg-1"></div>
                <div className="col-sm-10 col-md-10 col-lg-10">
                  <h1 className="new_password_details">New Password</h1>
                  <p className="login_with_email">Enter New Password</p>
                  <form>
                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Password"
                        name="password"
                        value={formData.password}
                        // onChange={handlePasswordChange}
                        onChange={handlePasswordValidation}
                        error={!!passwordError || !!passwordErrorMsg}
                        helperText={passwordErrorMsg || passwordError}
                        type={showPasswordOne ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPasswordOne}
                                onMouseDown={handleMouseDownPasswordOne}
                                edge="end"
                              >
                                {showPasswordOne ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          // style: {
                          //   border: "1px solid #1c5768",
                          //   borderRadius: "5px",
                          // },
                        }}
                        // InputProps={{
                        //     endAdornment: (
                        //         <InputAdornment position="end">
                        //             <VisibilityIcon />
                        //         </InputAdornment>
                        //     ),
                        //     style: { border: '1px solid #1c5768', borderRadius: '5px' }
                        // }}
                      />
                      {errors.password ? (
                        <p className="error text-danger">
                          Password should be atleast 5 characters long
                        </p>
                      ) : null}
                    </div>
                    <div>
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Confirm Password"
                        name="password_confirmation"
                        value={formData.password_confirmation}
                        // onChange={handlePasswordChange}
                        onChange={handlePasswordValidation}
                        error={!!passwordMatchError}
                        helperText={passwordMatchError}
                        type={showPasswordTwo ? "text" : "password"}
                        // InputProps={{
                        //     endAdornment: (
                        //         <InputAdornment position="end">
                        //             <VisibilityIcon />
                        //         </InputAdornment>
                        //     ),
                        //     style: { border: '1px solid #1c5768', borderRadius: '5px' }
                        // }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPasswordTwo}
                                onMouseDown={handleMouseDownPasswordTwo}
                                edge="end"
                              >
                                {showPasswordTwo ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          // style: {
                          //   border: "1px solid #1c5768",
                          //   borderRadius: "5px",
                          // },
                        }}
                      />
                      {errors.password_confirmation ? (
                        <p className="error text-danger">
                          Password confirmation should be atleast 5 characters
                          long
                        </p>
                      ) : null}
                    </div>
                    <div className="submit_details">
                      {/* <p className='Log_in'><Link to="/" className='back_to_log_in'>Back To Log in</Link></p> */}
                      {/* <p className='Log_in'><button className="btn btn-success" onClick={backtologinpage}>Back</button></p> */}
                    </div>
                    <div className="submit_details">
                      <button
                        className="submit"
                        type="button"
                        onClick={handleSubmitChangedPassword}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="text-center mt-3">
                      <button onClick={backtologinpage} className="log_in_now">
                        Go to previous page
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
              {/* <img src={TajMahal} className='tajmahal_image_new_password' alt='Taj Mahal' width="100%" height="150vh" /> */}
            </div>
            <div>
              <img
                src={TajMahal}
                className="tajmahal"
                alt="Tajmal image"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ChangedPasswordDetails;
